import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Progress } from '../components/ui/progress';
import {
  BarChart3,
  TrendingUp,
  Users,
  DollarSign,
  Target,
  ArrowUp,
  ArrowDown
} from 'lucide-react';

const Analytics = () => {
  const stats = [
    { label: 'Total Revenue', value: '$24,500', change: '+12%', up: true, icon: DollarSign },
    { label: 'Active Projects', value: '8', change: '+2', up: true, icon: Target },
    { label: 'Team Members', value: '12', change: '+3', up: true, icon: Users },
    { label: 'Conversion Rate', value: '68%', change: '-2%', up: false, icon: TrendingUp },
  ];

  const metrics = [
    { name: 'Business Formation', value: 85, target: 100 },
    { name: 'Marketing Goals', value: 62, target: 100 },
    { name: 'Sales Pipeline', value: 45, target: 100 },
    { name: 'Customer Satisfaction', value: 92, target: 100 },
  ];

  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-slate-800 mb-2">Analytics</h1>
          <p className="text-slate-600">Track your business performance and growth metrics</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {stats.map((stat, idx) => (
            <Card key={idx} className="border-0 shadow-lg">
              <CardContent className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-purple-100 to-teal-100 rounded-xl flex items-center justify-center">
                    <stat.icon className="w-6 h-6 text-purple-600" />
                  </div>
                  <Badge className={stat.up ? 'bg-teal-100 text-teal-700' : 'bg-red-100 text-red-700'}>
                    {stat.up ? <ArrowUp className="w-3 h-3 mr-1" /> : <ArrowDown className="w-3 h-3 mr-1" />}
                    {stat.change}
                  </Badge>
                </div>
                <p className="text-2xl font-bold text-slate-800">{stat.value}</p>
                <p className="text-sm text-slate-500">{stat.label}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Performance Metrics */}
        <Card className="border-0 shadow-lg">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <BarChart3 className="w-5 h-5 text-purple-500" />
              Performance Metrics
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-6">
              {metrics.map((metric, idx) => (
                <div key={idx}>
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-medium text-slate-700">{metric.name}</span>
                    <span className="text-sm text-slate-500">{metric.value}%</span>
                  </div>
                  <Progress value={metric.value} className="h-2" />
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Analytics;
